// extracted by mini-css-extract-plugin
export default {"content":"src-hellospa-components-app-shell-legacy-document-legacy-document-app-shell-module__content--2Nzo7"};